var exports = {
  "MK": "x61f99309--8972c2--menu",
  "AS": "x61f99309--8972c2--item",
  "gK": "x61f99309--8972c2--item--colored",
};

module.exports = exports;
